<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/E5EP7k/tc-custom/9781504059800.jpg?1706728662431" alt="This image is the cover for the book Cat Who Wasn't a Dog, The Trixie Dolan & Evangeline Sinclair Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cat Who Wasn't a Dog, The Trixie Dolan & Evangeline Sinclair Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A rescued cat is a clue to a killer’s identity in this cozy mystery by an “utterly entertaining” Agatha Award–winning author (<i>Booklist</i>).</b><br/>  <br/> Aging actress Dame Cecile Savoy is on the way to a Brighton taxidermist’s shop, accompanied by her friends Trixie and Evangeline—and her recently departed Pekingese. But when they arrive, they discover a dead body, a spreading fire, and a helpless Japanese bobtail cat in a cage.<br/>  <br/> After rescuing the endangered kitty, aka Cho-Cho-San, Trixie and Evangeline now have another heroic task to attempt: finding out who’s responsible, and what sort of person would bring a live cat to a place like that.<br/>  <br/> “Ailurophiles will want to snuggle up to British veteran Marian Babson’s latest comic feline cozy.” —<i>Publishers Weekly</i><br/>  <br/> The Cat Who Wasn’t a Dog <i>is the 6th book in the Trixie Dolan &amp; Evangeline Sinclair Mysteries, but you may enjoy reading the series in any order.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marian Babson
      </h2>
      
      <p class="authorDescription body article">Marian Babson, born Ruth Stenstreem, is an American mystery writer. Her first published work was <I>Cover-Up Story</I> (1971), and she has written over forty-five mysteries. Babson served as secretary of the Crime Writers&rsquo; Association and was awarded the CWA Dagger in the Library in 1996.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?39c25b9a